/** Код лобби P2P или полная/частичная ссылка с ?matchId= */
export function parseMysteryRoomP2pMatchIdFromUserInput(raw: string): string | null {
  const s = raw.trim();
  if (!s) return null;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'https://localhost';
    const u = s.startsWith('http') ? new URL(s) : new URL(s, base);
    const mid = u.searchParams.get('matchId')?.trim();
    // Совпадает с mr_generate_lobby_code(5): 5 символов; P2P id — до 32.
    if (mid && mid.length >= 5 && mid.length <= 128) return mid;
  } catch {
    /* не URL */
  }
  if (/^[a-zA-Z0-9_-]{5,32}$/.test(s)) return s;
  return null;
}
